import React from 'react';
import { Container } from "../styles/Container";
import { HeroImageContainer, HeroImageColoredBottom, HeroImageContent, HeroImageImage } from "../styles/HeroImage";

export const HeroImage = (props) => (
    <HeroImageContainer>
      <HeroImageColoredBottom bgColor={props.bgColor}/>
      <Container noPadding>
        <HeroImageContent>
          <HeroImageImage url={props.url} />
        </HeroImageContent>
      </Container>
    </HeroImageContainer>
  );

export default HeroImage;



// WEBPACK FOOTER //
// ./src/components/HeroImage.js